import {
    useContext, createContext,
} from 'react'
import {
    ContractCurrency,
} from 'app/enums/label.enums'

export type ContractBasisContextType = {
    contractId: number,
    currency?: ContractCurrency,
}

export const ContractBasisContext = createContext<ContractBasisContextType>(null)

const useContractBasisContext = () => {
    return useContext<ContractBasisContextType>(ContractBasisContext)
}

export default useContractBasisContext
